var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71429 0C9.76024 0 11.7224 0.812753 13.1691 2.25946C14.6158 3.70617 15.4286 5.66833 15.4286 7.71429C15.4286 10.908 12.9943 14.2543 8.22857 17.8286C8.0802 17.9398 7.89975 18 7.71429 18C7.52883 18 7.34837 17.9398 7.2 17.8286C2.43429 14.2543 0 10.908 0 7.71429C0 5.66833 0.812753 3.70617 2.25946 2.25946C3.70617 0.812753 5.66833 0 7.71429 0ZM7.71429 1.71429C6.12299 1.71429 4.59686 2.34643 3.47164 3.47164C2.34643 4.59686 1.71429 6.12299 1.71429 7.71429C1.71429 10.0371 3.52971 12.7166 7.24114 15.6909L7.71429 16.0646L8.18743 15.6909C11.8989 12.7166 13.7143 10.0371 13.7143 7.71429C13.7143 6.12299 13.0821 4.59686 11.9569 3.47164C10.8317 2.34643 9.30558 1.71429 7.71429 1.71429ZM7.71429 6C8.16894 6 8.60498 6.18061 8.92647 6.5021C9.24796 6.82359 9.42857 7.25963 9.42857 7.71429C9.42857 8.16894 9.24796 8.60498 8.92647 8.92647C8.60498 9.24796 8.16894 9.42857 7.71429 9.42857C7.25963 9.42857 6.82359 9.24796 6.5021 8.92647C6.18061 8.60498 6 8.16894 6 7.71429C6 7.25963 6.18061 6.82359 6.5021 6.5021C6.82359 6.18061 7.25963 6 7.71429 6Z",
    fill: "#38D68B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.65919558a3d28ada0267365f8600d46c.svg";
export { ForwardRef as ReactComponent };